import { START_CALL, STOP_CALL, GET_SESSION } from './constants'

export const getSession = {
  request: (userId) => ({ type: GET_SESSION.REQUEST, userId }),
  success: (data) => ({ type: GET_SESSION.SUCCESS, data })
}
export const startCall = {
  request: (data) => ({ type: START_CALL.REQUEST, data }),
  success: (data) => ({ type: START_CALL.SUCCESS, data })
}
export const stopCall = {
  request: (data) => ({ type: STOP_CALL.REQUEST, data }),
  success: (data) => ({ type: STOP_CALL.SUCCESS, data })
}
